<template>
  <div>
    <a @click="toggleHistory" class="cursor-pointer mb-3" href.prevent
      ><small>{{ !showHistory ? "View history" : "Hide history" }}</small></a
    >
    <Loading v-if="loading" />
    <ul class="vx-timeline mt-2" v-if="showHistory && !loading">
      <li
        v-for="item in stockProductHistory"
        :key="item.id"
        class="cursor-pointer"
        @click="show(item.id)"
      >
        <div class="timeline-icon bg-primary">
          <feather-icon
            icon="EditIcon"
            svgClasses="text-white stroke-current w-5 h-5"
          />
        </div>
        <div class="timeline-info">
          <p class="font-semibold">{{ item.title }}</p>
          <span class="activity-desc">{{ item.description }}</span>
        </div>
        <small class="text-grey activity-e-time">{{
          item.timestamp | date
        }}</small>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  name: "action-timeline",
  props: ["stockProductId"],
  data() {
    return {
      showHistory: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      stockProductHistory: "stockProducts/stockProductHistory",
    }),
  },
  methods: {
    async toggleHistory() {
      this.showHistory = !this.showHistory;

      if (this.showHistory) {
        this.loading = true;
        await this.$store.dispatch(
          "stockProducts/getStockProductHistory",
          this.stockProductId
        );
        console.log("Got history", this.stockProductHistory);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
